export const DISPLAY_SERVICE_MAIN_PC = 'HANSSEM_MAIN_PC'; // PC 웰컴 페이지
export const DISPLAY_SERVICE_MAIN_PC_HF = 'HF_MAIN_PC'; // PC 홈퍼니싱 메인
export const DISPLAY_SERVICE_MAIN_PC_INT = 'INT_MAIN_PC'; // PC 인테리어 메인
export const DISPLAY_SERVICE_PC_CATEGORY = 'CATEGORY_PC'; // PC 카테고리 페이지
export const DISPLAY_SERVICE_PC_CONSTCASE = 'INT_CONSTCASE_PC'; // PC 시공사례 페이지
export const DISPLAY_SERVICE_PC_MAGAZINE = 'INT_MAGAZINE_PC'; // PC 매거진 페이지

/**
 * PC 전체 인테리어 전시페이지 페이지코드.
 * 어드민: 전시 > 페이지 관리(신규) > 인테리어 > PC > 인테리어_전체
 * 접근 경로: /interior/all, /all
 */
export const DISPLAY_SERVICE_PC_INT_ALL = 'all';

/** 상담신청('무료 견적 상담') 플로팅 노출 대상 페이지코드인지 판정 (대소문자 무시) */
export const isConsultFloatingPageCode = (pageCode: string): boolean =>
  pageCode.toLowerCase() === DISPLAY_SERVICE_PC_INT_ALL.toLowerCase();
